import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalClose() {
  return <section className="bg-cream py-24 px-4" data-id="element-61">
      <div className="max-w-3xl mx-auto text-center" data-id="element-62">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-navy mb-10" data-id="element-63">
          Una última cosa antes de que decidas
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6 text-lg md:text-xl text-navy/80 mb-12" data-id="element-64">
          <p data-id="element-65">
            Dentro de algunos días podrías estar acostando a tu bebé con una
            rutina que funciona.
          </p>
          <p data-id="element-66">
            Podrías estar durmiendo más horas seguidas de las que dormiste en
            meses.
          </p>
          <p data-id="element-67">
            Podrías llegar al día siguiente con energía real para ser el padre o
            la madre que querés ser.
          </p>

          <div className="py-4" data-id="element-68">
            <p className="font-semibold text-navy" data-id="element-69">
              No porque hayas encontrado un truco mágico.
            </p>
            <p className="font-semibold text-navy" data-id="element-70">
              Sino porque entendiste cómo funciona el sueño de tu bebé y
              aplicaste un sistema con información real.
            </p>
          </div>

          <p data-id="element-71">
            Eso es todo lo que separa una noche caótica de una noche manejable.
          </p>

          <div className="text-2xl font-bold text-navy py-4" data-id="element-72">
            <p data-id="element-73">Información clara.</p>
            <p data-id="element-74">Un plan concreto.</p>
            <p data-id="element-75">Y la decisión de empezar.</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white p-8 rounded-2xl shadow-premium border border-gold/20 inline-block" data-id="element-76">
          <p className="text-2xl md:text-3xl font-bold text-navy mb-2" data-id="element-77">
            Tu bebé se merece dormir bien.
          </p>
          <p className="text-2xl md:text-3xl font-bold text-navy mb-4" data-id="element-78">
            Vos también.
          </p>
          <p className="text-xl text-sky font-semibold" data-id="element-79">
            Y esto es exactamente lo que necesitás para lograrlo.
          </p>
        </motion.div>
      </div>
    </section>;
}